/* eslint-disable import/no-extraneous-dependencies */
// eslint-disable-next-line import/no-namespace
import * as __linariaReact from '../../../../../node_modules/@linaria/react';

const linaria =
  'default' in __linariaReact ? __linariaReact.default : __linariaReact;

export const styled = (linaria as any).styled;
